module.exports = __webpack_public_path__ + "ir.f0236e88a274e52cd801.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/ir.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/ir.svg
// module chunks = styles